import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import Header from './Header';
import EventList from './EventList';
import CreateEventForm from './CreateEventForm';
import EditEventForm from './EditEventForm';

const EventsApp = () => {
	const [ currentRoute, setCurrentRoute ] = useState( '' );
	const [ eventId, setEventId ] = useState( null );

	// Parse hash route
	const parseRoute = () => {
		const hash = window.location.hash.slice( 1 ); // Remove #

		if ( ! hash || hash === '/' || hash === '/events' ) {
			return { route: 'list', id: null };
		}

		if ( hash === '/events/new' ) {
			return { route: 'create', id: null };
		}

		// Match /events/123 pattern
		const editMatch = hash.match( /^\/events\/(\d+)$/ );
		if ( editMatch ) {
			return { route: 'edit', id: parseInt( editMatch[ 1 ] ) };
		}

		// Default to list for unknown routes
		return { route: 'list', id: null };
	};

	// Update route state when hash changes
	useEffect( () => {
		const handleHashChange = () => {
			const { route, id } = parseRoute();
			setCurrentRoute( route );
			setEventId( id );
		};

		// Set initial route
		handleHashChange();

		// Listen for hash changes
		window.addEventListener( 'hashchange', handleHashChange );

		return () => {
			window.removeEventListener( 'hashchange', handleHashChange );
		};
	}, [] );

	// Navigation functions
	const navigateToList = () => {
		window.location.hash = '#/events';
	};

	const navigateToCreate = () => {
		window.location.hash = '#/events/new';
	};

	const navigateToEdit = ( id ) => {
		window.location.hash = `#/events/${ id }`;
	};

	// Handle successful create
	const handleEventCreated = ( event ) => {
		// Redirect to list with success state
		navigateToList();
		// TODO: Add success toast notification
	};

	// Handle successful edit
	const handleEventUpdated = ( event ) => {
		// Redirect to list with success state
		navigateToList();
		// TODO: Add success toast notification
	};

	// Render current view
	const renderCurrentView = () => {
		switch ( currentRoute ) {
			case 'create':
				return (
					<CreateEventForm
						onSave={ handleEventCreated }
						onCancel={ navigateToList }
					/>
				);

			case 'edit':
				return (
					<EditEventForm
						eventId={ eventId }
						onSave={ handleEventUpdated }
						onCancel={ navigateToList }
					/>
				);

			case 'list':
			default:
				return (
					<EventList
						onCreateNew={ navigateToCreate }
						onEditEvent={ navigateToEdit }
					/>
				);
		}
	};

	return (
		<div className="nb-events-app nb-flex nb-flex-col">
			<Header
				version={ nemtlyCreateEvent?.version || '' }
				pageName={ __( 'Events', 'nemtly-booking' ) }
			/>
			<div className="nb-flex nb-flex-col nb-flex-1">
				{ renderCurrentView() }
			</div>
		</div>
	);
};

export default EventsApp;
